import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, X, Check } from 'lucide-react';
export function ClosingSection() {
  return <section id="pricing" className="py-24 bg-cream px-4 border-t border-gold/20" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-forest mb-4" data-id="element-22">
            Tienes Dos Opciones
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch mb-16" data-id="element-23">
          {/* Option A */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white/50 p-8 rounded-2xl border border-gray-200 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-24">
            <h3 className="text-xl font-heading font-bold text-gray-600 mb-6" data-id="element-25">
              Opción A: Seguir probando soluciones genéricas
            </h3>
            <ul className="space-y-4" data-id="element-26">
              <li className="flex items-start text-gray-600" data-id="element-27">
                <X className="w-5 h-5 mr-3 mt-1 text-red-400" data-id="element-28" />
                Dietas restrictivas que te agotan
              </li>
              <li className="flex items-start text-gray-600" data-id="element-29">
                <X className="w-5 h-5 mr-3 mt-1 text-red-400" data-id="element-30" />
                Suplementos al azar sin resultados
              </li>
              <li className="flex items-start text-gray-600" data-id="element-31">
                <X className="w-5 h-5 mr-3 mt-1 text-red-400" data-id="element-32" />
                Más frustración y síntomas sin control
              </li>
            </ul>
          </motion.div>

          {/* Option B */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl border-2 border-gold shadow-xl relative overflow-hidden" data-id="element-33">
            <div className="absolute top-0 right-0 bg-gold text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-34">
              Recomendado
            </div>
            <h3 className="text-xl font-heading font-bold text-forest mb-6" data-id="element-35">
              Opción B: Dar un paso hacia un enfoque diseñado para ti
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-36">
              <li className="flex items-start text-warmBrown" data-id="element-37">
                <Check className="w-5 h-5 mr-3 mt-1 text-sage" data-id="element-38" />
                Microajustes personalizados a tu ritmo
              </li>
              <li className="flex items-start text-warmBrown" data-id="element-39">
                <Check className="w-5 h-5 mr-3 mt-1 text-sage" data-id="element-40" />
                Plan de 14 días fácil de seguir
              </li>
              <li className="flex items-start text-warmBrown" data-id="element-41">
                <Check className="w-5 h-5 mr-3 mt-1 text-sage" data-id="element-42" />
                Resultados reales y bienestar duradero
              </li>
            </ul>

            <div className="bg-cream rounded-xl p-6 text-center border border-sage/20" data-id="element-43">
              <div className="text-sm text-warmBrown/70 mb-1 uppercase tracking-wide" data-id="element-44">
                Precio Especial
              </div>
              <div className="text-4xl font-bold text-forest mb-2" data-id="element-45">
                $6,36 USD
              </div>
              <div className="text-sm text-sage mb-6" data-id="element-46">
                Acceso inmediato a la guía digital completa
              </div>

              <motion.a href="https://ritmovital360.com/cart/45776383344836:1" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-sage text-white py-4 rounded-full font-bold text-lg shadow-lg hover:bg-forest transition-colors duration-300 flex items-center justify-center gap-2" data-id="element-47">
                Da el Primer Paso Hoy
                <ArrowRight className="w-5 h-5" data-id="element-48" />
              </motion.a>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center max-w-2xl mx-auto" data-id="element-49">
          <p className="text-warmBrown/80 italic" data-id="element-50">
            "No te prometemos una cura milagrosa, pero sí una ruta clara para
            reducir bochornos, recuperar tu energía y sentirte mejor con tu
            cuerpo."
          </p>
        </motion.div>
      </div>
    </section>;
}